export const getListaAlumnosUNI = state => {
  return state.listaAlumnosUNI;
};

export const getListaAlumnosUNIquery = state => {
  return state.listaAlumnosUNIquery;
};

export const getAdminData = state => {
  return state.adminData;
};

export const getEditAlumnoDialog = state => {
  return state.editAlumnoDialog;
};

export const getEditAdministradorDialog = state => {
  return state.editAdministradorDialog;
};

export const getCreateAdministradorDialog = state => {
  return state.createAdministradorDialog;
};

export const getCreateNewDialog = state => {
  return state.createNewDialog;
};

export const getShowAlumnoInfoDialog = state => {
  return state.showAlumnoInfoDialog;
};

export const getNoChangeEdit = state => {
  // Estado usado para verificar si hubo algún cambio, y si es que hubo volver a hacer el fetch
  return state.noChangeEdit;
};

export const getSelectedAlumnoEdit = state => {
  return state.selectedAlumnoEdit;
};

export const getSelectedAlumnoInfo = state => {
  return state.selectedAlumnoInfo;
};

export const getSelectedAdministradorEdit = state => {
  return state.selectedAdministradorEdit;
};

export const getEstadisticaNuevosIngresos = state => {
  return state.estadisticaNuevosIngresos;
};

export const getListaAdministradores = state => {
  return state.listaAdministradores;
};

export const isAdminManager = state => {
  return state.adminData != null && state.adminData.adminType === 'MANAGER';
};

export const getDrawerState = state => {
  return state.drawer;
};

export const getListaNews = state => {
  return state.listaNews;
};
